export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              METALAGRO
            </h4>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Providing secure VPN solutions to protect your online privacy and ensure safe internet browsing.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">Quick Links</h5>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('features')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Features
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('how-it-works')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  How It Works
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('security')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Security
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">Support</h5>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-bold mb-4">Contact Info</h5>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-400 mt-1"></i>
                <a href="mailto:contact@metalagrosrl.com" className="text-gray-400 hover:text-teal-400 transition-colors">
                  contact@metalagrosrl.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-teal-400 mt-1"></i>
                <a href="tel:+18123016265" className="text-gray-400 hover:text-teal-400 transition-colors">
                  +1 812-301-6265
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span className="text-gray-400">
                  APOSTOLES NORTE 393<br />
                  Obera, N3365ACG<br />
                  Argentina
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} METALAGRO S.R.L. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="nofollow noopener noreferrer" 
              className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
